<template>
  <!--  推荐收益页面  -->
  <div class="ReferralIncome">
    <HeadNav/>
    <!--    推荐收益明细列表-->
    <div class="d18" v-if="tabIndex==1" v>{{langUtil(86)}}</div>
    <div class="d18" v-else>{{langUtil(79)}}</div>
    <div class="d19_wrap">
      <div class="d19" v-for="(item,index) in depositLog" :key="index">
        <div class="d22-1">
          <div class="d20" v-if="tabIndex==1">{{langUtil(60)}}: {{langUtil(86)}}<span>{{langUtil(32)}}:{{fmDate(item.time * 1000)}}</span></div>
          <div class="d20" v-else>{{langUtil(60)}}: {{langUtil(79)}}<span>{{langUtil(32)}}:{{fmDate(item.time * 1000)}}</span></div>
        </div>
        <div class="d21-1" v-if="tabIndex==1"> {{langUtil(55)}}(CD) <span>{{setUnit1(item.directReferrerIncome)}}</span></div>
        <div class="d21-1" v-else> {{langUtil(55)}}(CD) <span>{{setUnit1(item.cfcAmountSingle)}}</span></div>
      </div>
    </div>
    <ListEmpty v-if="depositLog.length === 0"/>
  </div>
</template>

<script>
  import HeadNav from "../components/HeadNav";
  import ListEmpty from "../components/ListEmpty";
  import {fmDate, showTotalData} from "../tools";
  import {setUnit1, getStartBlock, getEventData} from "../tools/chain";
  import {powerReleaseCreateBlock} from "../config"

  export default {
    name: "ReferralIncome",
    components: {
      HeadNav,
      ListEmpty
    },
    data() {
      return {
        tabIndex:'',
        depositLog: [
        ]
      }
    },
    mounted(){
      this.getList()
      this.tabIndex = this.$route.params.tabIndex//获取上级页面对tabindex
    },
    methods: {
      showTotalData(data) {
        return showTotalData(data)
      },
      fmDate(data) {
        return fmDate(data)
      },
      setUnit1(data) {
        return setUnit1(data)
      },
      async getList(toBlock){
        if (!toBlock){
          toBlock = await getStartBlock();
        }
        let list = [];
        const request = async (toBlock) => {
          console.log(toBlock, "等待者区块数");
          let fromBlock = toBlock - 100000;
          const eventConf = {
            fromBlock,
            toBlock,
            filter: {
              user: this.$store.state.accounts[0]
            },
          };
          var res
          if (this.tabIndex==1){
            res = await getEventData("LogDistributionIncome", eventConf);
          }else{
            res = await getEventData("LogBuyAndBurnLastDetail", eventConf);
          }
          console.log('___70', res)
          for (let k = res.length - 1; k >=0; k--) {
            list.push(res[k].returnValues)
          }
          if (fromBlock > powerReleaseCreateBlock) {
            await request(fromBlock)
          }
        }
        await request(toBlock);
        this.depositLog = list;
        console.log('___100', this.depositLog)
      },
    },

  }
</script>

<style scoped lang="less">
  .ReferralIncome {
    padding: 22px;
  }

  .d18 {
    font-weight: 400;
    font-size: 14px;
    color: #161718;
    margin-bottom: 7px;
  }

  .d19_wrap {
    display: flex;
    flex-direction: column;
  }

  .d19 {
    padding: 15px;
    background-color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .d20 {
    font-size: 10px;
    color: #000000;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    padding-left: 10px;

    span {
      color: #989898;
      padding-top: 7px;
    }
  }

  .d21-1 {
    font-size: 10px;
    color: #000000;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: end;

    span {
      font-size: 24px;
      font-weight: 600;
    }
  }

  .d22-1 {
    display: flex;
    align-items: center;
  }
</style>
